import { render } from "./MkSides.vue?vue&type=template&id=5deae5eb&scoped=true"
import script from "./MkSides.vue?vue&type=script&lang=js"
export * from "./MkSides.vue?vue&type=script&lang=js"

import "./MkSides.vue?vue&type=style&index=0&id=5deae5eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5deae5eb"]])

export default __exports__